export default {
  "user.submit": "Submit",
  "user.name.error":
    "Please enter the mobile phone number (China Mainland only) or email address",
  "user.pwd.error": "Please enter 6-16 characters password",
  "user.pwd.inlegal.error": "Contains illegal characters",
  "user.confirm.pwd.error": "Please input the identical password",
  "user.code.error": "Please enter the code",
  "user.agreement.error":
    "Please read and agree to XKool's user agreement and privacy policy",

  "user.login.welcome1": " ",
  "user.login.welcome2": "Sign in",
  "user.login.new": "Not a XKooler yet? Let's sign up now!",
  "user.login.wx": "Wechat",
  "user.login.name.placeholder": "Phone No. or Email Address",
  "user.login.pwd.placeholder": "Password",
  "user.login.forget.pwd": "Forgot password",
  "user.login": "Login",
  "user.login.account": "Password login",

  "user.login.code": "Verification code login",
  "user.login.code.send": "Get code",
  "user.login.code.send.ok": "The verification code has been sent successfully",
  "user.login.code.second": "second",
  "user.login.code.placeholder": "6 characters code",

  "user.register": "Sign up",
  "user.register.pwd.placeholder": "6-16 characters password",
  "user.register.agreement.txt1": "I've read and agree to XKool's ",
  "user.register.agreement.txt2": " and ",
  "user.register.agreement.user": "user agreement",
  "user.register.agreement.privacy": "privacy policy",
  "user.register.submit": "Create Account",
  "user.register.login": "Sign in",

  "user.act.suctxt1":
    "Using PC device access and experience XKool Design Cloud",
  "user.act.suctxt2": "Google Chrome is highly recommended",
  "user.act.url": "www.xkool.ai",
  "user.act.visit": "Visit a sample case",

  "user.bind.visit": "WeChat authorization",
  "user.bind.connect": "connect",
  "user.bind.submit": "Connect",
  "user.bind.login": "Sign in",

  "user.reset.pwd": "Reset password",
  "user.reset.pwd.new.placehoolder": "New password",
  "user.reset.pwd.confirm.placehoolder": "Enter the new password again",
  "user.reset.pwd.ok": "Submit",
  "user.reset.pwd.login": "Sign in",
  "user.reset.pwd.succuess": "Please login again",
};
